import React from 'react';
import { connect } from 'react-redux';
import { parentalLockSelector } from '../../../../../reducers/settings';
import { updateParentalLockConfirmed } from '../../../../../actions/videoPage';
import ParentalControl from './ParentalControl.jsx';

const ParentalControlContainer = (props) => {
    return <ParentalControl {...props} />;
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        parentalLockCode: parentalLockSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmParentalLock: () => {
            dispatch(updateParentalLockConfirmed(true));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParentalControlContainer);
